export enum SortWay {
    ASC = 'asc',
    DESC = 'desc',
}
